<template>
  <div>
  <div :class="fixFlag === true ? 'header headerFix' : 'header'" id="headerId">
    <div class="content">
      <div class="l">
        <img @click="goTab('/')" src="@/assets/img/index/icon/logo.jpg" class="logo" />
        <ul class="tab">
          <li v-for="(item, index) in tabList" :key="index"
              :class="(isTabSelected(item) || hoverIndex === index) ? 'selected' : '' "
              @click="goTab(item.url)"
              @mouseenter="hoverIndex = index"
              @mouseleave="hoverIndex = -1">
            <span v-if="item.children" class="tab-text">{{ item.name }}</span>
            <span v-else>{{ item.name }}</span>
            <div v-if="item.children" class="dropdown">
              <div v-for="(child, cIdx) in item.children" :key="cIdx"
                   class="dropdown-item"
                   @click.stop="goChildTab(child)">{{ child.name }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="r">
        <el-button type="primary" round class="use_btn"
                   @click="use">申请试用</el-button>
      </div>
    </div>
  </div>
    <Apply ref="applyRef" />
  </div>
</template>

<script>
import Apply from '@/views/pc/components/apply'
export default {
  name: "Header",
  components: { Apply },
  data () {
    return {
      tabList: [
        { name: '首页', url: '/' },
        { name: '系统介绍', url: '/sysIntro' },
        { name: '客户案例', url: '/cooperation' },
        { name: '解决方案', url: '/solution' },
        { name: '关于我们', url: '/about', children: [
          { name: '关于穗盈', url: '/about' },
          { name: '资讯中心', url: '/aboutInfo' },
        ]},
        { name: '集团官网', url: '', children: [ // /institute
          { name: '智慧农业', url: '', link: 'https://www.visfarm.com' },
          { name: '赛通科技', url: '', link: 'https://www.sciento.cn' },
          { name: '米果智能', url: '', link: 'https://www.megoai.com/index.html' },
          { name: '麦小菜', url: '', link: 'https://www.maixiaocai.com' },
        ]},
      ],
      tabUrl: '/',
      fixFlag: false,
      hoverIndex: -1
    }
  },
  mounted() {
    window.addEventListener('scroll',this.handleScroll)
    if (sessionStorage.getItem('tabUrl')) {
      this.tabUrl = sessionStorage.getItem('tabUrl')
    }
  },
  methods: {
    isTabSelected(item) {
      if (item.children && item.children.some(child => child.url === this.tabUrl)) {
        return true
      }
      return this.tabUrl === item.url
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop // 滚动条偏移量
      if (scrollTop > 40) {
        this.fixFlag = true
      }
      else {
        this.fixFlag = false
      }
    },
    goTab(url) {
      sessionStorage.setItem('tabUrl', url)
      window.scrollTo(0, 0)
      this.$router.push(url);
    },
    goChildTab(child) {
      if (child.link) {
        window.open(child.link, '_blank');
      } else {
        this.goTab(child.url);
      }
    },
    setItem() {
      sessionStorage.setItem("slt1", "");
      sessionStorage.setItem("slt2", "");
      sessionStorage.setItem("slt3", "");
      sessionStorage.setItem("slt4", "");
      sessionStorage.setItem("slt5", "");
      sessionStorage.setItem("ist1", "");
      sessionStorage.setItem("ist2", "");
      sessionStorage.setItem("ist3", "");
      sessionStorage.setItem("cpr1", "");
      sessionStorage.setItem("cpr2", "");
      sessionStorage.setItem("ab1", "");
      sessionStorage.setItem("ab2", "");
      sessionStorage.setItem("ab3", "");
      sessionStorage.setItem("ab4", "");
      sessionStorage.setItem("ab5", "");
      sessionStorage.setItem("ab6", "");
    },
    // 试用
    use () {
      // this.applyVisible = true
      this.$refs.applyRef.useClick();
      // this.closeApply()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pc/components/header.vue